module.exports = __webpack_public_path__ + "47a92b6e65fed8ebcf81b7b0a56f5431.png";